// extracted by mini-css-extract-plugin
export default {"filterRoot":"ProjectStatusesFilter_filterRoot__Sc2+7","label":"ProjectStatusesFilter_label__Yoduo","dropdown":"ProjectStatusesFilter_dropdown__m3FQt"};